import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slider-container" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = { class: "counter" }

import { computed, ref, toRefs } from 'vue'
import ImgSliderItem, { IMAGE_PROP } from '@/components/general/slider/ImgSliderItem.vue'
export interface IMAGE_LIST_PROPS {
  images: IMAGE_PROP[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImgSlider',
  props: {
    images: {}
  },
  setup(__props: any) {

const props = __props
const { images } = toRefs(props)
const currentImageUrl = ref<string>(images?.value[0]?.url ? images.value[0].url : '')
const firstArrow = computed(() => {
  return currentImageIndex.value === 0
})

const secondArrow = computed(() => {
  return currentImageIndex.value === images.value.length - 1
})

const currentImageIndex = ref(0)

const nextImage = () => {
  if (currentImageIndex.value >= images.value.length - 1) return
  currentImageIndex.value += 1
  currentImageUrl.value = images.value[currentImageIndex.value].url
}
const previousImage = () => {
  if (currentImageIndex.value === 0) return
  currentImageIndex.value -= 1
  currentImageUrl.value = images.value[currentImageIndex.value].url
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["sliderArrows", { disabled: firstArrow.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (previousImage()))
      }, "<", 2),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ImgSliderItem, { url: currentImageUrl.value }, null, 8, ["url"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["sliderArrows", { disabled: secondArrow.value }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (nextImage()))
      }, ">", 2)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(currentImageIndex.value + 1) + " / " + _toDisplayString(_unref(images).length), 1)
  ], 64))
}
}

})